import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { pickBy } from 'lodash';
import { amountFormater } from '../ManagePaymentListing/ColumnFormater';
import { dateFormat } from '../../../config';
import PaymentDetailsContainer from './PaymentDetailsContainer';
import { standingOrderPropTypes } from '../../../states/managePayments/propTypes';
import PaymentDetailsTable from './PaymentDetailsTable';
import { formatAccountToView } from '../../../utils/accountUtils';

const formatDate = (date) => moment(date).format(dateFormat);

export const StandingOrderDetails = ({ content, mandate }) => {
	const {
		fromLabel,
		toLabel,
		theirSortCodeLabel,
		theirAccountNumberLabel,
		amountLabel,
		typeLabel,
		refLabel,
		nextDueLabel,
		frequencyLabel,
		stopItWhenLabel,
		endDateLabel,
		noOfTimesLabel,
	} = content;

	const {
		fromAccount,
		to,
		amount,
		when,
		reference,
		mandateType,
		sort_code,
		account_number,
		frequency,
		endDate,
		numberOfTimes,
		stopWhen,
	} = mandate;

	const tableRowMapping = pickBy({
		[fromLabel]: formatAccountToView(fromAccount),
		[toLabel]: to,
		[theirSortCodeLabel]: sort_code,
		[theirAccountNumberLabel]: account_number,
		[refLabel]: reference,
		[typeLabel]: mandateType,
		[amountLabel]: amountFormater({ amount }),
		[nextDueLabel]: when,
		[frequencyLabel]: frequency,
		[stopItWhenLabel]: stopWhen,
		[nextDueLabel]: when,
		[endDateLabel]: endDate && formatDate(endDate),
		[noOfTimesLabel]: numberOfTimes,
	});
	return <PaymentDetailsTable tableRowMapping={tableRowMapping} />;
};

StandingOrderDetails.propTypes = {
	mandate: PropTypes.shape(standingOrderPropTypes),
	content: PropTypes.shape({
		fromLabel: PropTypes.string.isRequired,
		toLabel: PropTypes.string.isRequired,
		OneOffPaymenttype: PropTypes.string.isRequired,
		theirSortCodeLabel: PropTypes.string.isRequired,
		theirAccountNumberLabel: PropTypes.string.isRequired,
		amountLabel: PropTypes.string.isRequired,
		typeLabel: PropTypes.string.isRequired,
		refLabel: PropTypes.string.isRequired,
		whenLabel: PropTypes.string.isRequired,
	}),
};
export default PaymentDetailsContainer(StandingOrderDetails);
